import { ImageIcon } from "lucide-react";
import { mediaUrl, move, uid } from "@/lib/api";
import { Field, ItemControls, Panel, TempBadge, Toggle } from "./Fields";
import { UploadButton } from "./MediaInput";

export const GalleryTab = ({ items, onChange, onSetCover, cover }) => {
  const set = (i, patch) => onChange(items.map((g, k) => (k === i ? { ...g, ...patch } : g)));
  const add = (urls) => onChange([...items, ...urls.map((url) => ({ id: uid(), url, caption: "", active: true, temporary: false }))]);
  const temps = items.filter((g) => g.temporary).length;
  return (
    <Panel
      title="Galeria"
      desc={`${items.length} fotos${temps ? ` · ${temps} ilustrativas a substituir` : ""}. As fotos são comprimidas automaticamente no envio.`}
      actions={<UploadButton multiple onUploaded={add} label="Enviar fotos" testid="gallery-upload" />}
    >
      <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-4">
        {items.map((g, i) => (
          <div key={g.id} className={`border bg-[#08080A] ${g.active ? "border-white/10" : "border-white/5 opacity-60"}`} data-testid={`admin-gallery-item-${i}`}>
            <div className="relative aspect-[4/3] overflow-hidden">
              <img src={mediaUrl(g.url)} alt={g.caption} className="h-full w-full object-cover" loading="lazy" />
              <span className="absolute top-2 left-2 text-[0.6rem] bg-black/70 text-white px-2 py-1 tracking-widest">#{i + 1}</span>
              {g.temporary && <span className="absolute top-2 right-2"><TempBadge /></span>}
            </div>
            <div className="p-4 space-y-4">
              <Field label="Legenda" value={g.caption} onChange={(v) => set(i, { caption: v })} testid={`admin-gallery-item-${i}-caption`} />
              <div className="flex flex-col gap-3">
                <Toggle label="Visível no site" checked={g.active} onChange={(v) => set(i, { active: v })} testid={`admin-gallery-item-${i}-active`} />
                <Toggle label="Imagem ilustrativa" checked={g.temporary} onChange={(v) => set(i, { temporary: v })} testid={`admin-gallery-item-${i}-temporary`} />
              </div>
              <div className="flex items-center justify-between gap-2">
                <button type="button" onClick={() => onSetCover(g.url)} disabled={cover === g.url} className="inline-flex items-center gap-2 h-9 px-3 text-[0.65rem] uppercase tracking-[0.15em] border border-white/10 text-[#CBD5E1] hover:border-[#C5A059] disabled:text-[#C5A059] disabled:border-[#C5A059]/50" data-testid={`admin-gallery-item-${i}-set-cover`}>
                  <ImageIcon className="w-3.5 h-3.5" /> {cover === g.url ? "Capa do site" : "Usar como capa"}
                </button>
                <ItemControls onUp={() => onChange(move(items, i, -1))} onDown={() => onChange(move(items, i, 1))} onDelete={() => onChange(items.filter((_, k) => k !== i))} testid={`admin-gallery-item-${i}`} />
              </div>
            </div>
          </div>
        ))}
      </div>
    </Panel>
  );
};
